<template>
  <div
    :class="{
      apothekenfinder: true,
      fadeLoading: true,
      loading: dataStore.loading.apothekenfinder,
    }"
  >
    <div :class="dataStore?.otherInfo?.apothekenfinder?.type">
      <div v-if="headline || bodytext" class="mb-5 pb-2">
        <h1 v-if="headline" v-html="headline"></h1>
        <div v-if="bodytext" v-html="bodytext"></div>
      </div>
      <Form :defaultType="type" :resultsPerPage="resultsPerPage"/>
      <div class="results">
        <Pager :resultsPerPage="resultsPerPage"/>
        <ResultList  :resultsPerPage="resultsPerPage" />
        <Pager :resultsPerPage="resultsPerPage"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useDataStore } from "@/store/";
import Pager from "@/components/Pager";
import ResultList from "@/components/Apothekenfinder/ResultList";
import Form from "@/components/Apothekenfinder/Form";

const dataStore = useDataStore();
const defaultTypeUp = typeof defaultType !== 'undefined' ? defaultType : "embeddednotdienst";
const type = ref(defaultTypeUp);
const { otherInfo } = storeToRefs(dataStore);
const headline = ref("");
const bodytext = ref("");
const resultsPerPage = 50;

watch(
  otherInfo,
  (newVal, oldVal) => {
    type.value = newVal?.apothekenfinder?.type;
    setTexts();
  },
  { deep: true }
);

const setTexts = () => {
  if (type.value == "apotheken") {
    headline.value = headlineApotheken;
    bodytext.value = textApotheken;
  } else {
    headline.value = headlineNotdienst;
    bodytext.value = textNotdienst;
  }
};
</script>
